import { render, staticRenderFns } from "./TheSessions.vue?vue&type=template&id=60c92026&"
import script from "./TheSessions.vue?vue&type=script&lang=js&"
export * from "./TheSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports